import "./orderList.css"
import { DataGrid } from "@material-ui/data-grid"
// import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getOrders } from "../../redux/apiCalls"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { serverAPI } from "../../services/apiParams"

export default function OrderList() {
  const dispatch = useDispatch()
  const orders = useSelector((state) => state.order.orders)

  useEffect(() => {
    getOrders(dispatch)
  }, [])

  const handleChange = async (event, id) => {
    try {
      await serverAPI.put(`api/orders/${id}`, { status: event.target.value })
      getOrders(dispatch)
    } catch (error) {
      console.log(error.response)
    }
  }

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "product",
      headerName: " customer",
      width: 200,
      renderCell: (params) => {
        return (
          <div className='orderListItem'>
            last name here
            {params.row.first_name} {params.row.last_name}
          </div>
        )
      },
    },
    {
      field: "amount",
      headerName: "Total",
      width: 120,
    },
    {
      field: "status",
      headerName: "Status",
      width: 160,
    },
    {
      field: "address",
      headerName: "Address",
      width: 160,
    },
    {
      field: "action",
      headerName: "Change status",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            {/* <Link
            // to={"/order/" + params.row.id}
            >
              <button className='orderListEdit'>Info</button>
            </Link> */}
            <Select
              labelId='demo-simple-select-helper-label'
              id='demo-simple-select-helper'
              defaultValue={params.row.status}
              label='Age'
              onChange={(e) => {
                handleChange(e, params.row.id)
              }}>
              <MenuItem value={"completed"}>Completed</MenuItem>
              <MenuItem value={"processing"}>Processing</MenuItem>
              <MenuItem value={"pending"}>Pending</MenuItem>
            </Select>
          </>
        )
      },
    },
  ]

  return (
    <div className='orderList'>
      <DataGrid
        rows={orders}
        disableSelectionOnClick
        columns={columns}
        pageSize={8}
        checkboxSelection
        disableColumnMenu={true}
      />
    </div>
  )
}
